import { forwardRef } from 'react';

import BlackFridayPromoBanner from './BlackFridayPromotionBanner';
import { useGetBFResources } from './lib/useGetBFResources';
import PromotionBannerCard from './PromotionBannerCard';

const BANNER_VARIANTS = {
  LEADERBOARD: 'leaderboard',
  STANDARD: 'standard',
};

const BANNER_MAP = {
  [BANNER_VARIANTS.LEADERBOARD]: BlackFridayPromoBanner,
  [BANNER_VARIANTS.STANDARD]: PromotionBannerCard,
};

/**
 * @deprecated Should be removed in favor of PromoBannerPlace
 */
const PromotionBannerVariator = forwardRef((props, ref) => {
  const { bannerEyebrow, bannerMainPromoBenefit, bannerValueProp, promoBannerVariant } = useGetBFResources({
    isPollingEnabled: true,
  });
  const BannerComponent = BANNER_MAP[promoBannerVariant];

  if (!BannerComponent) {
    return null;
  }

  return (
    <BannerComponent
      {...props}
      bannerEyebrow={bannerEyebrow}
      bannerMainPromoBenefit={bannerMainPromoBenefit}
      bannerValueProp={bannerValueProp}
      innerRef={ref}
    />
  );
});
PromotionBannerVariator.displayName = 'PromotionBannerVariator';

export default PromotionBannerVariator;
